import React, { Component } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Link from 'next/link';
import he from 'he';

const Arrow = dynamic(() => import('../../../public/assets/arrows/smallarrow.js'));

export default class FeaturedArticles extends Component {
  render() {
    const s = require('./featured-article.module.scss');
    const { images, title, category_link, category, read_time, blurb, external, button } = this.props;
    return (
      <div className={s.Wrapper}>
        <div className={s.Container}>
          <Link href={`/article${button.link}`} passHref>
            <a className={s.ContainerCard}>
              <div className={s.Image} style={{ background: `url(${images.large}) no-repeat center` }} />
              <div className={s.Content}>
                <div className={s.Title}>
                  <h1>{title}</h1>
                </div>
                <div className={s.Category}>
                  <Link href={`/category${category_link}`} passHref>
                    <a className={s.CategoryLink}>{category}</a>
                  </Link>
                  <p>{read_time}</p>
                  <div className={s.Paragraph}>
                    {blurb && <p dangerouslySetInnerHTML={{ __html: he.decode(blurb) }}></p>}
                  </div>
                  {external ? <a className={s.ButtonMobile} target="_blank" rel="noopener noreferrer" href={button.link}>{button.label}<Arrow /></a> : <Link href={`/article${button.link}`}><a className={s.ButtonMobile}>{button.label}<Arrow /></a></Link>}
                </div>
              </div>
            </a>
          </Link>
        </div>
      </div>
    );
  }
}

FeaturedArticles.propTypes = {
  images: PropTypes.object,
  title: PropTypes.string,
  categoryLink: PropTypes.string,
  category: PropTypes.array,
  readTime: PropTypes.string,
  blurb: PropTypes.string,
  external: PropTypes.bool,
  button: PropTypes.object,
};